import { baseUrl } from '@/constants';
import { JwtAuthToken } from '@/core/domain/model/jwtAuthToken';
import axios, { AxiosResponse } from 'axios';
export interface RefreshRepository {
    (jwtAuthToken: JwtAuthToken): Promise<JwtAuthToken>
}

const refreshRepostory = (baseUrl: string): RefreshRepository => async (jwtAuthToken: JwtAuthToken) => {
    try {
        const response: AxiosResponse = await axios.get(baseUrl + '/session', {
            headers: {
                authorization: `Bearer ${jwtAuthToken.token} ${jwtAuthToken.refresh} ${jwtAuthToken.type}`
            }
        })

        const newJwtAuthToken: JwtAuthToken = response.data
        return newJwtAuthToken
    } catch (error) {
        throw error
    }
}

export default refreshRepostory